import pointerHelper from '@Common/Helpers/PointerHelper';
import { BaseControl } from '@Common/Controls/BaseControl';
import { selectMode } from '@Common/Controls/BaseMenu';
import { Popup } from '@Common/Controls/Popup';

export interface ICustomDropDownSetting {
    css?: any;
    className?: string;
    width?: string | number;
    height?: string | number;
    caption?: string;
    resizeble?: boolean;
    content?: any;
}

export class CustomDropDown extends BaseControl {
    private _onShowContent: IHandler;
    private _onRemoveContent: IHandler;
    private _onResizeStart: IHandler;
    private _onResizeStop: IHandler;
    private _onResize: IHandler;
    private _isContentVisible: any;
    private _titleControl: JQuery<HTMLElement>;
    private _arrow: JQuery<HTMLElement>;
    private _popup: Popup;
    private _onBeforeShowContent: any;

    constructor(param: ICustomDropDownSetting) {
        super(
            $.extend(
                {
                    css: null,
                    className: '',
                    width: '100%',
                    height: 30,

                    caption: '',

                    resizeble: false
                },
                param
            )
        );

        this._onShowContent = $.noop;
        this._onRemoveContent = $.noop;
        this._onResizeStart = $.noop;
        this._onResizeStop = $.noop;
        this._onResize = $.noop;
        this._isContentVisible = undefined;

        this._init();
    }

    protected _init() {
        // init root
        this._root = $('<div class="drop-down"/>');
        this._root
            .bind(
                pointerHelper.pointerDownEventName,
                function () {
                    this._isContentVisible = this._param.content.getControl
                        ? this._param.content.getControl().is(':visible')
                        : this._param.content.is(':visible');
                }.bind(this)
            )
            .click(
                function (e) {
                    e.stopPropagation();

                    if (this.enabled()) {
                        if (!this._isContentVisible) {
                            this._showContent();
                        } else if (
                            this._param.content.getControl ? this._param.content.getControl().is(':visible') : this._param.content.is(':visible')
                        ) {
                            this._removeContent();
                        }
                    }
                }.bind(this)
            );

        this._titleControl = $('<div class="name"/>').appendTo(this._root);
        this._arrow = $('<span class="dropdown-arrow"/>').appendTo(this._root);

        this._root.addClass(this._param.selectMode == selectMode.simple ? 'single' : 'multiple');
        this._root.addClass(this._param.titleStyle);
        this._root.toggleClass('component-drop-down', this._param.isComponent === true);
        this._root.css({ lineHeight: this._param.height + 'px' });

        this._param.margins && this._root.applyMargins(this._param.margins);

        this._applyDefaultParam();

        // init content
        /*this._content = $('<div class="drop-down-content popup-shadow"/>')
            .css({ 'top': this._param.lineHeight, position: 'absolute', maxHeight: this._param.maxContentHeight, minWidth: 200 })
            .addClass(this._param.contentStyle)
            .bind('removePopup', function () {

                this._removeContent();

            }).bind(pointerHelper.pointerDownEventName, function (e) {
                e.stopPropagation();
            });*/
        // init popup
        this._popup = new Popup({
            className: 'popup-gap',
            content: this._param.content.getControl ? this._param.content.getControl() : this._param.content,
            isHidden: true,
            jointHeight: this._param.height
        });

        this._popup.onClose(
            function () {
                this._onRemoveContent();
            }.bind(this)
        );

        if (this._param.resizable) {
            this._popup.getControl().resizable({
                minWidth: 200,
                minHeight: 50,
                stop: function () {
                    this._adjustContent();
                    this._onResizeStop();
                }.bind(this),
                resize: function () {
                    this._adjustContent();
                    this._onResize();
                }.bind(this),
                start: function () {
                    this._onResizeStart();
                }.bind(this)
            });
        }
    }

    _adjustContent() {
        this._param.content &&
            this._param.content.adjust &&
            this._param.content.adjust(this._popup.getControl().width(), this._popup.getControl().height());
    }

    _removeContent() {
        this._popup.hide();
        this._root.removeClass('clicked');
        this._onRemoveContent();
    }

    _showContent() {
        this._root.addClass('clicked');
        this._onBeforeShowContent && this._onBeforeShowContent();
        this._popup.show(this._root.offset().left, this._root.offset().top + 2);
        this._onShowContent();
    }

    setTitleDescription(titleDescription) {
        this._titleControl.text(titleDescription || '');
    }

    hideContent() {
        this._popup.hide();
        this._root.removeClass('clicked');
        this._onRemoveContent();
    }

    showContent() {
        this._showContent();
    }

    setTitleStyle(css) {
        this._root.css(css);
    }

    adjust(width, height?) {
        super.adjust(width, height);
        const h = this._root.outerHeight() - this._root.borderHeight();
        this._titleControl.css({
            height: h,
            lineHeight: h + 'px'
        });
    }

    /* Events */
    onShowContent(fn: IHandler) {
        $.isFunction(fn) && (this._onShowContent = fn);
    }

    onBeforeShowContent(fn: IHandler) {
        $.isFunction(fn) && (this._onBeforeShowContent = fn);
    }

    onRemoveContent(fn: IHandler) {
        $.isFunction(fn) && (this._onRemoveContent = fn);
    }

    onResizeStart(fn: IHandler) {
        $.isFunction(fn) && (this._onResizeStart = fn);
    }

    onResize(fn: IHandler) {
        $.isFunction(fn) && (this._onResize = fn);
    }

    onResizeStop(fn: IHandler) {
        $.isFunction(fn) && (this._onResizeStop = fn);
    }
}
